export const LS_MODAL_LOCALSTORAGE_PATH = 'ls.modal.dont.show';